module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage",
    attrs: {
      "id": "img2"
    }
  }, [_c('a', {
    attrs: {
      "id": "fm2"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/viii.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In a powerful evocation of Tesla’s formidable legacy, an electrical storm at the Kennedy Space Center in Cape Canaveral, Florida, creates an eerie tapestry of light in the hours preceding the launch of the space shuttle "), _c('em', [_vm._v("Challenger")]), _vm._v(" in 1983.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24049e66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454931959_epub_fm2_r1.vue
// module id = 75
// module chunks = 0